import { render, staticRenderFns } from "./home.vue?vue&type=template&id=c1427fa4"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=c1427fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeHeader: require('/usr/src/app/components/Home/Header.vue').default,TfFooterAll: require('/usr/src/app/components/tf/footer/all.vue').default})
